import type { FC } from 'react';
import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useParams } from 'react-router-dom';

import { useQuery } from '@apollo/client/react';

import { PageDocument } from '@graphql/platform';

import { Comparison } from '@root/components/landing_pages/smart_storage_v2/comparison';

import { PageBenefits } from './page/benefits';
import { PageBlurb } from './page/blurb';
import { PageCards } from './page/cards';
import { PageExplanations } from './page/explanations';
import { PageFacts } from './page/facts';
import { PageHero } from './page/hero';
import { PageMap } from './page/map';
import { PageReviews } from './page/reviews';
import { PageService } from './page/service';
import { PageContainer } from './page/shared';
import { PageTopics } from './page/topics';
import { Layout } from './shared/layout';

export const Page: FC = () => {
  const { slug } = useParams<{ slug: string }>();
  if (!slug) throw new Error(' missing slug');

  const { data } = useQuery(PageDocument, {
    variables: {
      slug,
    },
    skip: !slug,
  });

  const page = data?.page;
  if (!page) return null;

  return (
    <>
      <HelmetProvider context={global.helmetContext}>
        <Helmet>
          <title>{page.title} | Clutter</title>
          <meta name="description" content={page.description} />
        </Helmet>
      </HelmetProvider>

      <Layout>
        <PageContainer>
          <PageHero page={page} />
          <PageBlurb page={page} />
          <PageFacts page={page} />
          <PageExplanations page={page} />
          <PageBenefits page={page} />
          <Comparison />
          <PageReviews page={page} />
          <PageService page={page} />
          <PageMap page={page} />
          <PageTopics page={page} />
          <PageCards page={page} />
        </PageContainer>
      </Layout>
    </>
  );
};
